import { api } from './api';
import { getData, manageData } from './CRUD';
import { executeBackendQuery } from './executeBackendQuery';
import filter from '../filter';
import { FIRMS } from '../consts/tables';
import { FIRMS_LIST } from '../consts/queries';

/**
 * Add a firm. Rejects with `status === 409` and `code === 'DUPLICATE_FIRM'`
 * when a firm like it is already on file; pass `force` to add it regardless.
 *
 * @param {{NAME: string, ADDRESS?: string, CITY?: string, PHONE?: string, WEBSITE?: string}} firm
 * @param {{force?: boolean}} [options]
 * @returns {Promise<Object>} the new firm row
 */
export function createFirm(firm, { force = false } = {}) {
    return api.post('/firms', { ...firm, force }).then((res) => res.data);
}

/** The answer the firm save gives when saving would create a second Kore organization. */
export const CRM_CREATE_DUPLICATE = 'crm_create_duplicate';

/**
 * The firm page's save. Emptied fields travel as "" so a cleared value is
 * cleared; `confirmCrmCreate` is the user's yes to CRM_CREATE_DUPLICATE.
 */
export function saveFirmRow(row, { confirmCrmCreate = false } = {}) {
    const data = { ...row };
    delete data['undefined'];

    if (confirmCrmCreate) data.CONFIRM_CRM_CREATE = '1';

    return manageData({ tableCode: FIRMS, data: [data] });
}

function firmRow(id) {
    return getData({
        tableCode: FIRMS,
        options: {
            limit: { count: 1, offset: 0 },
            filter: [{ code: 'ARCIMEDES_ROW_ID', text: String(id), type: 'exact' }],
        },
    }).then((res) => (res && res.success && Array.isArray(res.data) && res.data.length ? res.data[0] : null));
}

/**
 * The firm row behind `firmId` as /firms shows it. One CRM organization can
 * sit in several FIRMS rows; the list shows one of them, and that is the row
 * whose edits the user sees.
 */
export function fetchListedFirm(firmId) {
    return firmRow(firmId).then((linked) => {
        if (!linked || !linked.CRM_ID) return linked;

        const options = filter({ CRM_ID: linked.CRM_ID }, 'firms');
        options.param.limit = 1;
        options.param.offset = 0;

        return executeBackendQuery({ queryName: FIRMS_LIST, options }).then((res) => {
            const listed = res && res.success && Array.isArray(res.data) ? res.data[0] : null;

            return listed && String(listed.ARCIMEDES_ROW_ID) !== String(linked.ARCIMEDES_ROW_ID)
                ? firmRow(listed.ARCIMEDES_ROW_ID)
                : linked;
        });
    });
}
